module.exports = __webpack_public_path__ + "static/media/icon-adherence-issue-sad.d6d3ccdc.svg";